import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Text,
  Link,
  ContainerText,
} from '../../../../styles';
import {
  TemplateDescription,
  TemplateDescriptionText,
} from '../styles';
import { LEARN_MORE_LINK } from '../constants';

const TemplateHeaderContent = ({
  handleCreateTemplate,
  description,
  title,
  buttonText,
  learnMoreLink,
}) => (
  <>
    <ContainerText>
      <Text>
        {title}
      </Text>
      <TemplateDescription>
        <TemplateDescriptionText>
          {description}
        </TemplateDescriptionText>
        <Link
          href={learnMoreLink || LEARN_MORE_LINK}
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more
        </Link>
      </TemplateDescription>

    </ContainerText>

    <Button
      onClick={handleCreateTemplate}
    >
      {buttonText}
    </Button>
  </>
);

TemplateHeaderContent.defaultProps = {
  learnMoreLink: null,
};

TemplateHeaderContent.propTypes = {
  handleCreateTemplate: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  learnMoreLink: PropTypes.string,
};

export default TemplateHeaderContent;
